export default __webpack_public_path__ + "static/buy-0d69f69f74b77736d5168c363a156ed5.png";